import atman_1025 from './img/atmansound_1025.png';
import atman_412 from './img/atman_412.png';
import atman_315 from './img/atmansound_0315.png';
import atman_222 from './img/atman_222.png';
import atmanSound from './img/atmansound.png';
import './App.css';

    function App() {
    return (
        <div className="App">
        <header className="App-header">
            <img className="AtmanScaled" src={atman_1025} alt="Atman Sound" />
            <a
            className="App-link"
            href="https://soundcloud.com/thomasb"
            target="_blank"
            rel="noopener noreferrer"
            >
            soundcloud.com/thomasb
            </a>
            <a
            className="App-link"
            href="https://soundcloud.com/djscallywags"
            target="_blank"
            rel="noopener noreferrer"
            >
            soundcloud.com/djscallywags
            </a>
        </header>
            <div className="PastEvents">
                <p>Past Events</p>
				<img className="AtmanScaled" src={atman_412} alt="Atman Sound" />
                <img className="AtmanScaled" src={atman_315} alt="Atman Sound" />
                <img className="AtmanScaled" src={atman_222} alt="Atman Sound" />
                <img className="AtmanScaled" src={atmanSound} alt="Atman Sound" />
            </div>
        </div>
    );
}

export default App;
